import { Injectable } from '@angular/core';
import { DynamicModalLoaderService } from '../../layout/services/dynamic-modal-loader.service';
import { PlaceholderModalComponent } from '../../layout/components/modals/placeholder-modal/placeholder-modal.component';
import { MODES, PatientEditingComponent } from '../components/patient-editing/patient-editing.component';
import { PlaceholderModalLoaderPayload } from '../../layout/classes/placeholder-modal-loader-payload';
import { map } from 'rxjs/operators';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { ModalTypes } from '../../layout/components/modals/contants/modal-types.enum';

@Injectable()
export class PatientInfoService {

  constructor(
    private _http: HttpInterceptorService,
    private modalLoaderService: DynamicModalLoaderService
  ) {
  }

  openPatientInfo(patientId: string);
  openPatientInfo(patientId: string, orgId: string, orgName: string);
  openPatientInfo(patientId: string, orgId?: string, orgName?: string) {

    const mode = patientId ? MODES.UPDATE : MODES.CREATE;
    let approveBTN, declineBTN;

    if (mode === MODES.UPDATE) {
      approveBTN = 'Close';
    } else {
      approveBTN = 'Create patient';
      declineBTN = 'Cancel';
    }

    const patientDetailsPayload = new PlaceholderModalLoaderPayload(
      'Patient Details',
      PatientEditingComponent,
      approveBTN,
      declineBTN,
      {
        'patientId': patientId,
        'mode': mode,
        'orgId': orgId,
        'orgName': orgName
      }
    );
    patientDetailsPayload.setCssClasses('new-patient-modal Auto_New-patient ');

    return this.modalLoaderService.popupModal(PlaceholderModalComponent, patientDetailsPayload, ModalTypes.CUSTOM)
      .pipe(
        map(response => response.payload)
      );
  }

  getPatientMergeFromInfo(patient) {
    // mergeInfo can be an array of patients that were merged to a given patient
    if (patient && patient.mergedFrom && patient.mergedFrom.length > 0) {
      return patient.mergedFrom;
    }
  }

  getPatientMergeToInfo(patient) {
    // get if current user was merged before to other patient
    if (patient && patient.mergedTo) {
      return patient.mergedTo;
    }
  }
}
